export const CONTENT_PUBLISHED_STATES = {
  ARCHIVED: 'Archived',
  DRAFT: 'Draft',
  UNSYNCED: 'Pending changes',
  PUBLISHED: 'Published',
} as const;
